<template>
	<div class="account">
		<section class="d-flex flex-column">
			<header class="masthead mb-auto">
				<HomeNav />
			</header>
		</section>
		<section class="py-5 bg-grey200" v-if="showAcc">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<ul class="list-group custom-list-group">
							<li class="list-group-item">
								<h4 class="text-uppercase pb-3 pt-3">
									Membership
									<span class="pull-right d-inline-block w-lg-25 w-md-75 w-100">
										<a
											v-if="showCancelSubs && subs.paymentStatus != 'CANCELLED'"
											@click="cancleSubs"
											class="btn btn-outline-light"
											>Cancel Membership</a
										>
										<a
											v-if="showRenewSubs"
											@click="renewSubscription"
											class="btn btn-outline-light"
											>Renew Membership</a
										>
									</span>
								</h4>
								<p>
									<strong>Email:</strong> {{ email }}
									<a href="/#/update-email" class="pull-right w-lg-25 w-md-75 w-100"
										>{{ getText("change_email_text")
										}}<i class="fa fa-angle-right"></i
									></a>
								</p>
								<p>
									<strong>Password:</strong> *******
									<a href="/#/update-password" class="pull-right w-lg-25 w-md-75 w-100"
										>{{ getText("change_password_text")
										}}<i class="fa fa-angle-right"></i
									></a>
								</p>
								<p>
									<strong>Phone:</strong> {{ phone }}
									<img
										v-if="
											this.mobileVerified == false && showVerification == true
										"
										class="error-icon col-center"
										src="../assets/img/warning.svg"
										alt=""
									/>
									<a href="/#/updatephone" class="pull-right w-lg-25 w-md-75 w-100"
										>{{ getText("change_phone_number")
										}}<i class="fa fa-angle-right"></i
									></a>
								</p>

								<p><strong>User Id:</strong> {{ uid }}</p>
							</li>
							<li class="list-group-item" v-if="showSubs">
								<h4 class="text-uppercase">Subscription</h4>
								<p>
									<strong>Plan ID:</strong> {{ subs.package }}
									<a href="javascript:void(0)" class="pull-right w-lg-25 w-md-75 w-100"
										>View History<i class="fa fa-angle-right"></i
									></a>
								</p>
								<p>
									<strong>Plan:</strong> {{ subs.sub }}
									<a
										href="javascript:void(0)"
										class="pull-right w-lg-25 w-md-75 w-100"
										@click="changeSubs"
										>{{ getText("change_package_text") }}
										<i class="fa fa-angle-right"></i
									></a>
								</p>
								<p><strong>Price:</strong> {{ subs.price }}NGN</p>
								<p><strong>Duration:</strong> 30 Days</p>
								<p>
									<strong>Screens:</strong> 2 Screens
									<a href="javascript:void(0)" class="pull-right w-lg-25 w-md-75 w-100"
										>Upgrade To 5 screens <i class="fa fa-angle-right"></i
									></a>
								</p>
								<p><strong>Promo:</strong> 20% Discount</p>
								<p
									v-if="
										subs &&
										subs.expiry_date &&
										subs.paymentStatus == 'SUCCESS' &&
										subs.recurring == true
									"
								>
									<strong>Subscription Renews On:</strong>
									{{ getExpiryDate(subs) }}
									<a href="javascript:void(0)" class="pull-right w-lg-25 w-md-75 w-100"
										>View History <i class="fa fa-angle-right"></i
									></a>
								</p>
								<p
									v-if="
										(subs &&
										subs.expiry_date &&
										subs.paymentStatus == 'CANCELLED') ||
										subs.recurring == false
									"
								>
									<strong>Subscription Expires On:</strong>
									{{ getExpiryDate(subs) }}
									<a href="javascript:void(0)" class="pull-right w-lg-25 w-md-75 w-100"
										>View History <i class="fa fa-angle-right"></i
									></a>
								</p>
							</li>
							<li
								class="list-group-item"
								v-if="
									this.data.paymentProvider === 'braintree' ||
										this.data.paymentProvider === 'stripe'
								"
							>
								<h4 class="text-uppercase">Payment Method:</h4>
								<p>{{ this.data.paymentProvider }}</p>
								<p>
									<span class="img pointer"
										><img src="../assets/img/mastercard.png" /> •••• •••• ••••
										1234 Exp.09/22</span
									>
									<a
										href="javascript:void(0)"
										@click="goToUpdatecard"
										class="pull-right w-lg-25 w-md-75 w-100"
										>Update Payment Info <i class="fa fa-angle-right"></i
									></a>
								</p>
							</li>
							<li class="list-group-item">
								<h4 class="text-uppercase">Subscription</h4>
								<p><strong>Payment Method:</strong> Manual</p>
								<p><strong>Payment Channel: </strong> Bank Transfer</p>
								<p v-if="subs"><strong>Recurring Payment: </strong><span v-if="subs && subs.recurring== true && subs.paymentStatus == 'SUCCESS'">Active</span> <span v-else-if="(subs && subs.recurring== false)|| subs.paymentStatus == 'CANCELLED'">Inactive</span></p>
							</li>
							<li class="list-group-item text-center" v-if="showAddSubs">
								<h5>Currently You have no Subscriptions</h5>
								<p class="d-inline-block w-lg-25 w-md-75 w-100">
									<a @click="addSubs" class="btn btn-outline-light"
										>ADD SUBSCRIPTION</a
									>
								</p>
							</li>
							<li class="list-group-item text-center">
								<p class="d-inline-block w-lg-25 w-md-75 w-100">
									<a @click="deleteAccount()" class="btn btn-outline-light"
										>Delete Account</a
									>
								</p>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import HomeNav from "@/components/HomeNav.vue";
import moment from "moment";
export default {
	name: "Account",
	components: {
		HomeNav,
	},
	data() {
		return {
			data: null,
			showAcc: false,
			showSubs: false,
			provider_slug: "",
			mobileVerified: null,
			showVerification: null,
			telephone: "",
			showAddSubs: false,
			showCancelSubs: false,
			showRenewSubs: false,
			subscHistory: false,
			expiryDate: "",
			previousSubsList: null,
			renewSubsId: null,
			renewPaymentgateway: null,
			globalConfig: null,
		};
	},
	mounted() {
		window.scroll(0, 0);
	},
	created() {
		this.init();
		this.globalConfig = this.$store.getters.getGlobalConfigs;
	},
	methods: {
		getText(val) {
			return this.$store.getters.getGlobalConfigs[val];
		},
		verifyTelephone() {
			if (this.telephone) {
				this.showVerification = true;
			} else {
				this.showVerification = false;
			}
		},
		addSubs() {
			this.$store.commit("setLoader", true);
			var Data = {
				token: this.$store.state.user.accessToken,
			};
			this.$store.dispatch("getClientToken", Data).then((res) => {
				if (res) {
					this.$store.commit("setBTClientToken", res.token);
					this.$store.commit(
						"tempUserToken",
						this.$store.state.user.accessToken
					);
					this.$store.commit("setLoader", false);
					this.$router.push("/packages");
				}
			});
		},
		cancleSubs() {
			if (this.showSubs) {
				this.$store.commit("setLoader", true);
				if (this.data.subscriptions[0].paymentStatus == "CANCELLED") {
					this.$store.commit(
						"setNotification",
						"You Current Subscriptions is Already Cancelled"
					);
				}
				if (
					this.data.subscriptions[0].payment_gateway == "braintree" ||
					this.data.subscriptions[0].payment_gateway == "stripe"
				) {
					var cancelSubsDataToSendBraintree = {
						subscriptionId: this.data.subscriptions[0].sub_id,
						slug: this.data.subscriptions[0].payment_gateway,
					};
					this.cancelSubsById(cancelSubsDataToSendBraintree);
				} else if (
					this.data.subscriptions[0].payment_gateway == "flutterwave" ||
					this.data.subscriptions[0].payment_gateway == "dpo"
				) {
					var getSubsDataToSend = {
						transaction_id: this.data.subscriptions[0].transaction_id,
						slug: this.provider_slug,
					};
					this.$store
						.dispatch("getSubscription", getSubsDataToSend)
						.then((res) => {
							var cancelSubsDataToSendFlutter = {
								id: res.data[0].id,
								subscriptionId: this.data.subscriptions[0].sub_id,
								slug: this.data.subscriptions[0].payment_gateway,
							};

							this.cancelSubsById(cancelSubsDataToSendFlutter);

							// have to check slug is flutterwave or braintree
						})
						.catch((err) => {
							this.$store.commit("setLoader", false);
						});
				} else {
					this.cancelSubsById({
						subscriptionId: this.data.subscriptions[0].sub_id,
					});
				}
			} else {
				this.$store.commit(
					"setNotification",
					"Currently you have no subscriptions"
				);
			}
		},

		changeSubs() {
			this.$router.push("/changesubscription");
		},

		gotoUpdatePassword() {
			this.$router.push("/updatepassword");
		},
		logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/login");
				}
			});
		},
		cancelSubsById(data) {
			this.$store
				.dispatch("cancleSubsById", data)
				.then((res) => {
					if (res) {
						this.init();
						this.showCancelSubs = false;
						this.showSubs = false;
						this.$store.commit("setLoader", false);
						this.$store.commit("setNotification", res.message);
					}
				})
				.catch((err) => {
					this.$store.commit("setLoader", false);
				});
		},
		getExpiryDate(item) {
			if (item.expiry_date) {
				return moment(item.expiry_date, "YYYY-MM-DD").format("ll");
			} else {
				return "";
			}
		},
		init() {
			this.$store.commit("showPopup", false);
			this.$store.commit("showdefaultFooter", true);
			if (this.$store.state.user.logedin == false) {
				this.$store.commit("setLoader", false);
				this.$router.push("/login");
				return false;
			} else {
				this.$store.commit("setLoader", true);
				if (this.$store.getters.getGlobalConfigs.provider_slug) {
					this.provider_slug = this.$store.getters.getGlobalConfigs.provider_slug;
				}
				this.$store.dispatch("account",{forceFetch:true}).then((res) => {
					if (res) {
						this.data = res.response;
						this.mobileVerified = res.response.profile.mobileVerified;
						this.telephone = res.response.profile.telephone;
						this.verifyTelephone();
						this.subscHistory = res.response.subscriptionHistory;
						if (this.subscHistory == false) {
							this.showAddSubs = true;
						}
						if (this.subscHistory == true) {
							if (
								res.response.subscriptions.length > 0 &&
								res.response.subscriptions[0].paymentStatus == "SUCCESS"
							) {
								this.showCancelSubs = true;
							} else if (
								res.response.subscriptions.length > 0 &&
								res.response.recurring
							) {
								this.showCancelSubs = true;
							} else if (
								res.response.subscriptions.length == 0 ||
								res.response.subscriptions[0].paymentStatus == "FAILED" ||
								res.response.subscriptions[0].paymentStatus == "EXPIRED"
							) {
								this.showRenewSubs = true;
							}
						}

						this.previousSubsList = res.response.subscriptionList;
						this.previousSubsPlan();
						this.$store.commit("setLoader", false);
						if (this.data.subscriptions.length == 0) {
							this.showSubs = false;
						} else {
							this.showSubs = true;
						}
						this.showAcc = true;
					}
				});
			}
		},
		previousSubsPlan() {
			if (this.previousSubsList.length > 0) {
				this.renewSubsId = this.previousSubsList[0].sub_id;
				this.renewPaymentgateway = this.previousSubsList[0].payment_gateway;
			}
		},
		//   renewSubscription(){
		// 		var dataToSend = {
		//     	subscriptionId:this.renewSubsId ,
		//     	slug:this.renewPaymentgateway
		// 		};
		// 		this.$store.commit("setLoader", true);
		// 		this.$store
		// 			.dispatch("retryPayment", dataToSend)
		// 			.then((res) => {
		// 				this.$store.commit("setLoader", false);
		// 				if (res.status == 200) {
		// 					this.$store.commit(
		// 						"setNotification",
		// 						" Payment Request sent Sucessfully!! "
		// 					);

		// 				}
		// 			})
		// 			.catch((err) => {
		// 				this.$store.commit("setLoader", false);
		// 				this.$store.commit("setNotification", " Error while making payment ");
		// 				this.$router.push("/account");
		// 			});

		// },
		renewSubscription() {
			this.addSubs();
		},
		goToUpdatecard() {
			if (this.data.paymentProvider == "stripe") {
				this.$router.push("/striperenewupdatecard");
			} else if (this.data.paymentProvider == "braintree") {
				this.$router.push("/braintreerenewupdatecard");
			}
		},
		deleteAccount(){
			this.$router.push("/deleteaccount");
		}
	},
	computed: {
		subscription() {
			const subscriptions = this.data.subscriptions;
			let subscriptionString = subscriptions[0].package;

			return subscriptionString;
		},
		email() {
			if (this.data.profile) {
				return this.data.profile.username;
			}
		},
		fullname() {
			return this.data.name[0].toUpperCase() + this.data.name.slice(1);
		},
		address() {
			var profile = this.data.profile;
			return (
				profile.address +
				", " +
				profile.city +
				", " +
				profile.state +
				", " +
				profile.country +
				""
			);
		},
		phone() {
			return this.data.profile.telephone;
		},
		uid() {
			return this.data.profile.id;
		},
		subs() {
			if (this.data.subscriptions.length >= 0) {
				return this.data.subscriptions[0];
			} else {
				return [];
			}
		},
	},
};
</script>

<style scoped>
.error-icon {
	transform: translate(-0%, -20%);
}

.py-5 {
	padding-top: 10rem !important;
	padding-bottom: 10rem !important;
	min-height: 80vh;
}

p {
	margin-top: 0;
	margin-bottom: 1rem;
	font-size: 20px;
}
</style>
